export interface IStyledProps {
  styles?: React.DetailedHTMLProps<React.StyleHTMLAttributes<HTMLStyleElement>, HTMLStyleElement>;
}

/** @ts-ignore */
export { styled, use, css } from './reshadow-core';

export { sstyled } from './sstyled';
